import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"40%"} }

import BaseAutoCompleteWithSingleSelectedItem from "@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue"
import FormRow from "@/components/Common/FormRow.vue"
import getRole from "@/types/responses/getRole"
import { computed } from "vue"
import i18n from "@/lang/i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleName',
  props: {
    roles: {},
    modelValue: {},
    windowInnerWidth: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRow, {
    title: _unref(i18n).global.t('pages.roleAssignment.form.roleName'),
    windowInnerWidth: props.windowInnerWidth,
    required: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseAutoCompleteWithSingleSelectedItem, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          itemName: "display_name",
          items: props.roles,
          errorMessages: props.errorMessages
        }, null, 8, ["modelValue", "items", "errorMessages"])
      ])
    ]),
    _: 1
  }, 8, ["title", "windowInnerWidth"]))
}
}

})